import { graphql, Script, ScriptStrategy, useStaticQuery } from "gatsby";
import * as React from "react";
import { PropsWithChildren } from "react";

import { Post } from "../../contexts/blog/domain/post";

type PropsPost = PropsWithChildren<{
  post: Partial<Queries.SanityPost>;
}>;

const PostMarkupSchema: React.FC<PropsPost> = (props: PropsPost) => {
  const { dataJson } = useStaticQuery(graphql`
    query PostMarkup {
      dataJson {
        blogName
        legalName
        logotypeUrl
        socialLinks {
          facebook
          instagram
          linkedin
        }
      }
    }
  `);
  const { blogName, legalName, logotypeUrl, socialLinks } = dataJson;
  const { post } = props;
  const author =
    Array.isArray(post.author) && post.author?.length > 0
      ? post.author[0]
      : null;
  if (!author) {
    console.error("No author found", post);
    return <></>;
  }
  const markup = `
  {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://thecookies.agency/${post.slug}/"
    },
    "headline": "${post.title}",
    "description": "${post.seo?.desc}",
    "image": "${post.thumbnail?.secure_url}",
    "author": {
      "@type": "Person",
      "name": "${author.name || "TheCookies"}",
      "image": "${
        author.summary?.photo?.asset?.secure_url || post.thumbnail?.secure_url
      }",
      "sameAs": [
        "${author.socials?.instagram || socialLinks.instagram}",
        "${author.socials?.linkedin || socialLinks.linkedin}",
        "${author.socials?.twitter || socialLinks.twitter}"
      ],
      "jobTitle": "${author?.job || "Desarrollo y diseño web"}",
      "worksFor": {
        "@type": "Organization",
        "name": "${legalName}"
      }
    },
      "publisher": {
      "@type": "Organization",
      "name": "${blogName}",
      "logo": {
        "@type": "ImageObject",
        "url": "${logotypeUrl}"
      }
    },
    "datePublished": "${post.publishedAt}",
    "dateModified": "${post.updatedAt}"
  }
  `;

  return (
    <Script strategy={ScriptStrategy.postHydrate} type="application/ld+json">
      {markup}
    </Script>
  );
};

export default PostMarkupSchema;
